import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { Field } from 'react-final-form';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useValidator from '@swf/core/hooks/useValidator';

import { CardType } from '../../../../../../types/cardType';
import Checkbox from '../../../../../Checkbox/Checkbox';

import { TXTWCL_I_agree_and_allow_payment_proc_ELL } from './TermsAndConditions.messages.json';

export interface Props {
  type?: CardType;
}

export const eCheckTermsAndConditions = 'eCheckTermsAndConditions';

const TermsAndConditions: React.FC<Props> = ({ type }) => {
  const [validator] = useValidator(required());

  return type === CardType.ECheck ? (
    <Field
      name={eCheckTermsAndConditions}
      initialValue={false}
      type="checkbox"
      validate={validator}
    >
      {({ input: { onChange, checked }, meta }) => (
        <Checkbox
          meta={meta}
          name={eCheckTermsAndConditions}
          checked={checked}
          onChange={onChange}
          label={
            <Translation
              {...TXTWCL_I_agree_and_allow_payment_proc_ELL}
              values={{
                a: (msg: React.ReactNode) => (
                  <ResolverLink resolverTag={ResolverTag.RealMoneyEcheckTerms}>{msg}</ResolverLink>
                )
              }}
            />
          }
        />
      )}
    </Field>
  ) : null;
};

export default TermsAndConditions;
